/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Legal_Loading_SettingsInputs */

const en_admin_legal_loading_settings = /** @type {(inputs: Admin_Legal_Loading_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading settings…`)
};

const de_admin_legal_loading_settings = /** @type {(inputs: Admin_Legal_Loading_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen werden geladen…`)
};

/**
* | output |
* | --- |
* | "Loading settings…" |
*
* @param {Admin_Legal_Loading_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_legal_loading_settings = /** @type {((inputs?: Admin_Legal_Loading_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Legal_Loading_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_legal_loading_settings(inputs)
	return en_admin_legal_loading_settings(inputs)
});